import Vue from 'vue'
import Vuex from 'vuex'

// import modules
import Files from './modules/files'
import SlicingProfiles from './modules/slicingProfiles'
import printerTypes from './modules/printerTypes'
import Printers from './modules/printers'
import Download from './modules/download'
import Configs from './modules/config'
import User from './modules/user'
import Chat from './modules/chat'
import Slicer from './modules/slicer'


Vue.use(Vuex)
// Vue.use(axios, {})



export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Files,
    SlicingProfiles,
    printerTypes,
    Printers,
    Download,
    Configs,
    User,
    Chat,
    Slicer
  }
})
